import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { ModalHeader } from 'components/ModalElements/component.styles.js'

export const SectionsWrapper = styled.div`
  margin: -0.313rem 0 1.188rem;
`

export const StyledModalHeader = styled(ModalHeader)`
  margin-bottom: 1.25rem;
`

export const SectionGoal = styled.p`
  &:not(:last-child) {
    margin-bottom: 1.063rem;
  }
`

export const SectionTitle = styled.span`
  font-family: ${themeGet('font.molde.medium')};
`
